import * as React from "react";
import { forwardRef } from "react";
const SvgFormatting = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M6.75 4.875V8.625C5.71875 8.625 4.875 7.78125 4.875 6.75C4.875 5.71875 5.71875 4.875 6.75 4.875ZM14.25 3H6.75C4.67812 3 3 4.67812 3 6.75C3 8.82188 4.67812 10.5 6.75 10.5V15.1875H8.625V4.875H10.5V15.1875H12.375V4.875H14.25V3Z", fill: "#4555D6" }));
const ForwardRef = forwardRef(SvgFormatting);
export { ForwardRef as ReactComponent };
